var _defs, _g, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.97 57.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}.c{stroke-width:1.52px;}.c,.d{fill:#669;stroke:#fff;stroke-miterlimit:10;}.d{stroke-width:2.76px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.46,29.72c.19-.59,.18-1.22-.15-1.9-.56-1.13-1.6-1.94-2.55-2.73-1.57-1.31-3.17-2.58-4.8-3.81-2.97-2.25-6.05-4.36-9.22-6.31-2.94-1.81-5.96-3.47-9.06-4.97-2.89-1.4-5.85-2.65-8.87-3.73-2.84-1.02-5.72-1.89-8.65-2.6-2.77-.67-5.57-1.2-8.4-1.58s-5.4-.58-8.12-.66-5.21-.03-7.81,.15-4.99,.46-7.47,.85c-2.38,.38-4.75,.87-7.1,1.45-2.26,.56-4.49,1.21-6.7,1.94-2.11,.7-4.2,1.48-6.26,2.32-1.96,.81-3.9,1.67-5.8,2.6-1.8,.87-3.57,1.8-5.31,2.77-1.62,.9-3.22,1.85-4.79,2.84-1.43,.9-2.85,1.83-4.24,2.79-1.24,.86-2.46,1.74-3.66,2.65-1.03,.78-2.05,1.57-3.05,2.39-1.06,.87-2.29,1.68-3.2,2.69-.4,.44-.81,.92-.86,1.51-.05,.64,.34,1.22,.72,1.74,.85,1.16,2.1,2.03,3.22,2.95,.97,.8,1.95,1.58,2.95,2.34,1.17,.89,2.36,1.77,3.56,2.61,1.36,.96,2.75,1.88,4.15,2.78,1.54,.98,3.11,1.93,4.71,2.84,1.72,.98,3.46,1.91,5.23,2.79,1.88,.94,3.79,1.82,5.73,2.64,2.04,.86,4.1,1.66,6.19,2.38s4.39,1.42,6.63,2.01c2.32,.61,4.67,1.12,7.03,1.53,2.45,.43,4.93,.75,7.41,.95,2.58,.21,5.17,.3,7.76,.27,2.7-.04,5.39-.21,8.07-.53s5.6-.81,8.36-1.43c2.91-.66,5.79-1.47,8.61-2.43,3.01-1.02,5.96-2.21,8.84-3.55,3.09-1.43,6.1-3.03,9.03-4.77,3.16-1.88,6.23-3.92,9.2-6.09,1.76-1.29,3.48-2.62,5.17-3.99,1.14-.92,3.02-2.15,3.52-3.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.48,
    cy: 28.79,
    r: 27.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 64.56,
    cy: 28.7,
    r: 13.81
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 57.32,
    cy: 21.88,
    r: 6.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b99acb36ddf229c8445028570f7cfd19.svg";
export { ForwardRef as ReactComponent };